var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import getItems from './getItems';
import { classNames } from '@tpr/core';
import styles from './popup.module.scss';
var PopupBox = function (_a) {
    var getItemProps = _a.getItemProps, inputValue = _a.inputValue, options = _a.options, highlightedIndex = _a.highlightedIndex, selectedItem = _a.selectedItem, handleNotFoundButtonClick = _a.handleNotFoundButtonClick, notFoundMessage = _a.notFoundMessage, optionPreview = _a.optionPreview, _b = _a.searchable, searchable = _b === void 0 ? false : _b;
    var filteredOptions = searchable ? getItems(options, inputValue) : options;
    return (React.createElement(React.Fragment, null, !filteredOptions.length ? (React.createElement("div", { role: "button", className: styles.button, onClick: handleNotFoundButtonClick, children: notFoundMessage })) : (filteredOptions.map(function (item, index) {
        var _a, _b;
        return (React.createElement("div", __assign({ role: "button" }, getItemProps({
            key: index,
            index: index,
            item: item,
            className: classNames([
                (_a = {}, _a[styles.active] = highlightedIndex === index, _a),
                (_b = {},
                    _b[styles.selected] = selectedItem && selectedItem.value === item.value,
                    _b),
                styles.button,
            ]),
        })), optionPreview ? optionPreview(item) : item.label));
    }))));
};
export default PopupBox;
//# sourceMappingURL=popup.js.map